import React, { useState, useEffect } from 'react';
import api from "../api";
const ImageViewer = ({ fileName }) => {
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    api.get("api/get_image_url/" ,{
        params:{
         file_Name: fileName},
    })
      .then((response) => {
        setImageUrl(response.data.url)
      })
      .catch(error => console.error('Error fetching image URL:', error));
  }, [fileName]);
  console.log(imageUrl);
  return (
    <div>
      {imageUrl ? <img src={imageUrl}  /> : <p>Loading...</p>}
    </div>
  );
};

export default ImageViewer;